import type {
  RoofGenerationTemporaries,
  RoofDormerWallBaseBoardSection,
} from "building-types/roofs/roofGenerationTypes";
import type { Plane } from "geom/planeTypes";
import type { PolyLine2 } from "geom/polyLine2Types";

export function roofGenerationTemporariesNew(): RoofGenerationTemporaries {
  return {
    extraHipFaces: [],
    startBaseExtension: 0,
    endBaseExtension: 0,
  };
}

export function roofDormerWallBaseBoardSectionNew(
  segments: PolyLine2[],
  clipPlane?: Plane | null,
  startCapPlane?: Plane | null,
  endCapPlane?: Plane | null,
): RoofDormerWallBaseBoardSection {
  return {
    segments,
    clipPlane,
    startCapPlane,
    endCapPlane,
  };
}
